import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import PropTypes from 'prop-types';
import ViewGridData from '../../components/table-elements/view-grid-data.component';
import {
  VIEW_BRD_COLUMNS,
  VIEW_GUMGUM_COLUMNS,
  VIEW_VFR_COLUMNS,
} from '../../config/module-configs/apps.config';

const TABS_CONFIG = [
  { value: 'BRD', label: 'Bright-SDK', columns: VIEW_BRD_COLUMNS },
  { value: 'VFR', label: 'VFR', columns: VIEW_VFR_COLUMNS },
  { value: 'GumGum', label: 'GumGum', columns: VIEW_GUMGUM_COLUMNS },
];

const AppThirdPartyIntegrationsView = ({ channelDetail }) => {
  const [tabValue, setTabValue] = useState(TABS_CONFIG[0].value);

  return (
    <Box height="100%" display="flex">
      <Tabs
        value={tabValue}
        aria-label="tabs"
        orientation="vertical"
        variant="scrollable"
        scrollButtons="auto"
        indicatorColor="transparent"
        sx={{ minWidth: 150, maxWidth: 150 }}
        onChange={(_, v) => setTabValue(v)}
      >
        {TABS_CONFIG.map((tab, index) => (
          <Tab
            key={index + 1}
            value={tab.value}
            label={tab.label}
            sx={{
              background: tabValue === tab.value && '#f2f2f2',
              borderLeft: tabValue === tab.value && '2px solid #FD0100',
              alignItems: 'flex-start',
              textAlign: 'left',
            }}
          />
        ))}
      </Tabs>

      <Box flexGrow={1}>
        <ViewGridData
          columns={
            TABS_CONFIG.filter((tab) => tab.value === tabValue)[0]?.columns
          }
          row={channelDetail}
        />
      </Box>
    </Box>
  );
};

AppThirdPartyIntegrationsView.propTypes = {
  channelDetail: PropTypes.object.isRequired,
};

export default AppThirdPartyIntegrationsView;
